module.exports = __webpack_public_path__ + "static/media/gno.4572ee10.svg";